/* eslint-disable */
import React from 'react';
import LegalPage from '../components/LegalPage';

const ReturnPolicy = () => (
  <LegalPage eyebrow="AT THE MAISON" title="Return &amp; Refund" italicTail="Policy.">
    <p>Due to hygiene and safety reasons, cosmetic products cannot be returned after delivery unless one of the eligible cases below applies.</p>

    <h2>Eligible Cases</h2>
    <ul>
      <li>Wrong product received</li>
      <li>Product damaged during transit</li>
      <li>Missing product in order</li>
    </ul>

    <h2>Reporting Window</h2>
    <p>Customers must notify us within <strong>48 hours of delivery</strong>. Please provide:</p>
    <ul>
      <li>Order number</li>
      <li>Photos of the product</li>
      <li>Photos of the outer packaging</li>
      <li>An unboxing video (recommended)</li>
    </ul>

    <h2>Refund Process</h2>
    <p>Approved refunds will be processed within <strong>5–10 business days</strong> to the original payment method.</p>

    <h2>Non-Returnable Cases</h2>
    <p>Returns or refunds will not be accepted for:</p>
    <ul>
      <li>Change of mind</li>
      <li>Shade preference issues</li>
      <li>Minor packaging variations</li>
      <li>Incorrect product selection by customer</li>
      <li>Allergic reactions due to individual sensitivities</li>
    </ul>
    <p className="mt-6">We recommend performing a patch test before use.</p>
  </LegalPage>
);

export default ReturnPolicy;
